var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h39v30H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(.01887 0 0 .02453 0 -.175)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 53,
    height: 55,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA3CAYAAACsLgJ7AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAMoSURBVGhD7ZjBTxNBFIf9C71z586dO3fueNYzniXxQNIeSDRiookIJqC11ADSatWiY792X/NoZnfftNPZLtlf8lKWdmfeN2/em7f7yD1ANVB1UQNVFzVQdVEDVRctDTUY/XXd4ci9uf41s1Zv6F50fphN34sx3jJaCAqQp2ff3War4x6/vFiZbb+6dAedQTarXcFQrOTG4WevE6uyzXYnKHpBUKyab9IUFgJmhmJA32QpDbDB6F/mUb7MUOxv30SpjVwukwmKPPJNUIVtHH7JvMqXCYrV8U1QlZ32/2Se+WWC2jn+5h28KuNsK5IJapl82n7dc3sfbmYH7f553+2+uxon/Vfv7y1WllcrgwLmeJyLRQJyEbgoUKGdw7NPt9mdU3EcSKQoOnQkou7wzm0ddb3j5BmRL1J0KA102v+dG+Xd91ezwxTIEDDuLVJUKLaSiO6DdooSzMq2ez8n25Fo7bydFh7dJRAxa/uVFEpyCEdxEEic9YmCwT26S7AeHcmgdJSobvxPA7XGkcJpckokYJL41lYsGZRMRH7oa8R2oxriPPDAiIgo34lC5spTNChZbWmpxHGut44uJ39PHyjv7m05iarIcnwkg6IAIIGSaz5xAiBxhvGkQKw1lETq47iM62tgdJXbP7+9l39A6CZ1raB0XkwrXye7cpNyDoj8TgqIFAbtpKWsJ4NitedLs0QrTxIVgZStW2bJoDANIR3Ck5Ob2dYTsUUFSHcglq2HJYUiWgIwKQxZEcBwGNPtkAYi1+T/ZZYUCtPlGpFPnFPkFNB80jbpBz16RN9YeZYc6vlF+Hs6orp3cu0dz2dJoTQQSU9E+JwXEJxffK/zzQpWVoBMUNYElm3nyw9yiXHmF4jtKlvRWv2iQFnfUeC4Lg5Wk8cTAH3fz1sUqEUcXaW1e8PMM79MUCHlNoVFeUVGYvsGr8J035gnExSSR/Cq7SDr/otkhpo+By3+ri6G6aa5SGYoVCUYD5q6UylSEBQCLOR1VgyjKbYCoWAoET0dpX4VgJxbjMvZVfaW16eFoXyi5VnWYigq1LqogaqLGqi6qIGqix4glHP/AQaiDRHfV9JZAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMin);
export default __webpack_public_path__ + "static/media/logo-min.bcf8849a7ced597079b9f994e242031b.svg";
export { ForwardRef as ReactComponent };